import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { AppLayoutComponent } from 'shared-lib';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppLayoutComponent, MenuComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'JJames Smart Parking - Organisation';
}
